var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5-.5a18,18,0,0,1,7.007,34.585A18,18,0,0,1,10.493.915,17.888,17.888,0,0,1,17.5-.5Zm0,35A17,17,0,0,0,29.521,5.479,17,17,0,1,0,5.479,29.521,16.889,16.889,0,0,0,17.5,34.5Z",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,16.707,11.293,12,16,7.293,16.707,8l-4,4,4,4Z",
    transform: "translate(-0.375 5.5)",
    fill: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5.5H-.5v-1h10Z",
    transform: "translate(12.5 17.5)",
    fill: "#dfe1e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeftArrow);
export default __webpack_public_path__ + "static/media/carousel-left-arrow.a009503a830ecabd0ef4a7325b142acd.svg";
export { ForwardRef as ReactComponent };